import { useCallback, useContext } from 'react';
import { UserContext } from '@namespace/user';

const useGetLimits = () => {
  const [, { GET_LIMITS }] = useContext(UserContext);
  const fetchLimits = useCallback(async () => {
    await GET_LIMITS({
      types: ['max_deposit', 'game_activity', 'exclusion_tracking']
    });
  }, [GET_LIMITS]);
  return {
    fetchLimits
  };
};

export default useGetLimits;
